import type { MoodCategoryType } from '@/types/domain/childNotebook/valueObjects/moodCategory';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 機嫌
 */
export class MoodCategory extends PrimitiveValueObject<MoodCategoryType> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: MoodCategoryType): MoodCategory {
    return new MoodCategory(value);
  }
}
